var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.4707 175C58.0481 175 24.4707 141.423 24.4707 100C24.4707 58.5774 58.0481 25 99.4707 25C140.893 25 174.471 58.5774 174.471 100C174.471 141.423 140.893 175 99.4707 175Z",
    fill: "url(#paint0_linear_26801_588)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1251 124.542C20.9975 124.542 11.1667 114.711 11.1667 102.583C11.1667 90.4557 20.9975 80.625 33.1251 80.625C45.2527 80.625 55.0834 90.4557 55.0834 102.583C55.0834 114.711 45.2527 124.542 33.1251 124.542Z",
    fill: "url(#paint1_linear_26801_588)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3618 110.347C26.5312 111.516 28.4271 111.516 29.5964 110.347L33.1253 106.818L36.6541 110.347C37.8235 111.516 39.7194 111.516 40.8887 110.347C42.0581 109.177 42.0581 107.282 40.8887 106.112L37.3599 102.583L40.8887 99.0545C42.0581 97.8851 42.0581 95.9892 40.8887 94.8199C39.7194 93.6505 37.8235 93.6505 36.6541 94.8199L33.1253 98.3487L29.5964 94.8199C28.4271 93.6505 26.5312 93.6505 25.3618 94.8199C24.1925 95.9892 24.1925 97.8851 25.3618 99.0545L28.8907 102.583L25.3618 106.112C24.1925 107.282 24.1925 109.177 25.3618 110.347Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.875 124.542C152.747 124.542 142.917 114.711 142.917 102.583C142.917 90.4557 152.747 80.625 164.875 80.625C177.003 80.625 186.833 90.4557 186.833 102.583C186.833 114.711 177.003 124.542 164.875 124.542Z",
    fill: "url(#paint2_linear_26801_588)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.112 110.347C158.281 111.516 160.177 111.516 161.346 110.347L164.875 106.818L168.404 110.347C169.573 111.516 171.469 111.516 172.639 110.347C173.808 109.177 173.808 107.282 172.639 106.112L169.11 102.583L172.639 99.0545C173.808 97.8851 173.808 95.9892 172.639 94.8199C171.469 93.6505 169.573 93.6505 168.404 94.8199L164.875 98.3487L161.346 94.8199C160.177 93.6505 158.281 93.6505 157.112 94.8199C155.942 95.9892 155.942 97.8851 157.112 99.0545L160.641 102.583L157.112 106.112C155.942 107.282 155.942 109.177 157.112 110.347Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 100,
    r: 31,
    fill: "url(#paint3_linear_26801_588)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 143C75.2512 143 56 123.749 56 100C56 76.2512 75.2512 57 99 57C122.749 57 142 76.2512 142 100C142 123.749 122.749 143 99 143ZM68.2857 100C68.2857 116.964 82.0365 130.714 99 130.714C115.964 130.714 129.714 116.964 129.714 100C129.714 83.0365 115.964 69.2857 99 69.2857C82.0365 69.2857 68.2857 83.0365 68.2857 100Z",
    fill: "#F7CE46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8276 96.6838C84.0175 95.4975 85.9467 95.4975 87.1366 96.6838L96.1855 105.706L114.714 87.2325C115.904 86.0462 117.833 86.0462 119.023 87.2325C120.213 88.4188 120.213 90.3422 119.023 91.5286L98.3399 112.15C97.1501 113.336 95.2209 113.336 94.031 112.15L82.8276 100.98C81.6377 99.7936 81.6377 97.8701 82.8276 96.6838Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1211 147.555L92.2475 121.503C92.262 118.491 94.7248 116.015 97.7201 116C100.716 115.986 103.154 118.44 103.139 121.45L103.036 142.835C103.587 140.321 105.828 138.415 108.481 138.402C111.489 138.387 113.957 140.82 113.999 143.845C114.829 142.16 116.556 140.988 118.536 140.978C121.305 140.965 123.559 143.231 123.545 146.015L123.541 146.837C124.446 145.625 125.884 144.832 127.49 144.825C130.196 144.811 132.397 147.026 132.384 149.745C132.323 162.251 132.314 164.083 132.272 172.684C132.261 175.035 131.726 177.054 130.571 179.109C130.2 179.768 130 180.527 129.996 181.339L129.972 186.331C129.967 187.306 129.173 188.104 128.204 188.109L96.919 188.262C95.9498 188.266 95.1633 187.475 95.168 186.5L95.1924 181.509C95.2007 179.854 94.3949 178.436 92.9769 177.61L87.4658 174.399C84.349 172.583 82.1034 169.797 81.8012 166.175L81 156.58C81.0267 151.134 84.8266 147.591 90.2403 147.564L92.1211 147.555Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.141 145.439C125.842 145.052 126.642 144.829 127.49 144.825C130.196 144.812 132.397 147.026 132.383 149.745C132.323 162.251 132.314 164.083 132.272 172.684C132.261 175.035 131.727 177.054 130.57 179.109C130.2 179.768 130 180.527 129.996 181.339L129.972 186.331C129.967 187.306 129.173 188.105 128.204 188.109L123.512 188.132C124.481 188.127 125.275 187.329 125.28 186.354L125.304 181.362C125.308 180.55 125.508 179.792 125.879 179.132C127.035 177.077 127.569 175.058 127.581 172.707C127.622 164.106 127.631 162.275 127.692 149.768C127.701 147.901 126.666 146.272 125.141 145.439ZM113.999 143.845C113.956 140.82 111.489 138.387 108.48 138.401C107.643 138.406 106.846 138.599 106.131 138.939C107.981 139.808 109.276 141.684 109.307 143.867L109.289 147.41C109.283 148.713 110.328 149.764 111.624 149.758C112.92 149.752 113.975 148.69 113.981 147.387C113.987 146.206 113.993 145.026 113.999 143.845ZM116.186 141.576C117.778 142.42 118.862 144.104 118.853 146.038C118.849 146.871 118.845 147.704 118.841 148.537C118.834 149.84 119.88 150.891 121.175 150.885C122.471 150.879 123.526 149.817 123.533 148.514C123.537 147.681 123.541 146.848 123.545 146.015C123.558 143.231 121.305 140.964 118.535 140.978C117.689 140.982 116.89 141.198 116.186 141.576ZM95.3709 116.549C96.0839 116.201 96.8809 116.004 97.7197 116C100.715 115.985 103.154 118.439 103.139 121.45C103.097 130.134 103.055 138.818 103.012 147.502C103.006 148.805 101.951 149.867 100.655 149.873C99.3593 149.879 98.3138 148.828 98.3204 147.525C98.3624 138.841 98.4047 130.157 98.4468 121.473C98.4574 119.305 97.1962 117.426 95.3709 116.549ZM87.4271 147.927C88.3013 147.694 89.2431 147.57 90.2403 147.565L92.1211 147.556L92.0666 158.747C92.0601 160.05 91.0046 161.111 89.7092 161.118C88.4138 161.124 87.3682 160.073 87.3745 158.77L87.4271 147.927Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.192 181.508L129.995 181.339L129.971 186.331C129.967 187.305 129.172 188.104 128.203 188.109L96.9189 188.261C95.9497 188.266 95.1633 187.475 95.168 186.5L95.192 181.508Z",
    fill: "url(#paint4_linear_26801_588)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.304 181.362L129.996 181.339L129.972 186.331L129.971 186.376L129.969 186.422L129.966 186.466L129.962 186.511L129.956 186.555L129.95 186.599L129.943 186.643C129.94 186.658 129.937 186.673 129.935 186.687L129.925 186.729L129.915 186.772L129.903 186.814L129.891 186.856L129.877 186.897L129.863 186.938L129.847 186.978C129.842 186.992 129.836 187.005 129.83 187.018C129.819 187.044 129.807 187.071 129.795 187.097L129.776 187.135L129.756 187.173L129.735 187.21C129.72 187.235 129.705 187.26 129.69 187.283L129.667 187.319L129.642 187.354L129.617 187.388L129.591 187.422C129.574 187.445 129.556 187.466 129.537 187.488C129.519 187.51 129.5 187.531 129.48 187.551L129.45 187.582L129.42 187.611C129.4 187.631 129.378 187.65 129.357 187.669C129.335 187.687 129.314 187.705 129.292 187.723L129.258 187.749L129.224 187.774L129.189 187.799L129.154 187.823C129.13 187.838 129.106 187.853 129.081 187.868L129.044 187.888L129.007 187.909L128.968 187.928C128.943 187.941 128.916 187.952 128.89 187.964L128.85 187.98L128.81 187.996L128.77 188.011L128.728 188.024L128.687 188.037L128.645 188.049L128.603 188.059L128.56 188.069L128.517 188.077L128.474 188.085L128.43 188.091L128.386 188.097L128.342 188.101L128.297 188.104L128.252 188.106L128.207 188.107L123.515 188.13C124.484 188.125 125.278 187.326 125.283 186.352L125.304 181.362Z",
    fill: "#3460DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_588",
    x1: 24.4707,
    y1: 36.7188,
    x2: 167.439,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_588",
    x1: 33.1251,
    y1: 80.625,
    x2: 33.1251,
    y2: 124.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_588",
    x1: 164.875,
    y1: 80.625,
    x2: 164.875,
    y2: 124.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_588",
    x1: 74.7812,
    y1: 69,
    x2: 146.478,
    y2: 113.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_588",
    x1: 96.909,
    y1: 188.529,
    x2: 128.014,
    y2: 180.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleChoice);
export default __webpack_public_path__ + "static/media/Single-Choice.2ad34e1be77896b09dc600749809c737.svg";
export { ForwardRef as ReactComponent };